import { render, staticRenderFns } from "./Reviewrecords.vue?vue&type=template&id=3c056c51&scoped=true"
import script from "./Reviewrecords.vue?vue&type=script&lang=js"
export * from "./Reviewrecords.vue?vue&type=script&lang=js"
import style0 from "./Reviewrecords.vue?vue&type=style&index=0&id=3c056c51&prod&lang=css"
import style1 from "./Reviewrecords.vue?vue&type=style&index=1&id=3c056c51&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c056c51",
  null
  
)

export default component.exports